import 'css-chunksrc/client/common/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_15oi8_1",
  "checked": "_checked_15oi8_14"
};